import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
// import { useHistory } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import './LiveApplication.css';
import { CommonBaseURl } from '../../../Commonprovider/CommonProvider';

const Carddetails = ({ actionUrl, formValue, title, description, path, userid, pWdid }) => {
    const UserDetails = useSelector(state => state.LoginUserDetails.data)
    const Token = useSelector(state => state.Authenticationapi.token)
    // const [liveU, setLiveU] = useState('');
    // const [liveP, setLiveP] = useState('');

    const handleSubmitLive = async () => {
        const Ucode = UserDetails[0].UserId || JSON.parse(UserDetails)[0].UserId
        const params = new URLSearchParams();
        params.append('test', 'Abc');
        params.append('UserId', window.btoa(Ucode));
        params.append('test2', 'Abc');
        let liveU, liveP
        try {
            debugger
            const response = await fetch(`${CommonBaseURl}GetLiveAppValues`, { // Replace with real API URL
                method: 'POST',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: `Bearer ${Token.access_token}`,
                },
                body: params.toString(),
            });

            if (!response.ok) throw new Error('Network response was not ok');
            const encryptedBase64 = await response.text();  // replace this with actual data source
            const Ciphertext = encryptedBase64.replace(/^"|"$/g, '')
            let rootScope = []
            function _0x14af() {
                var _0x2eed78 = [
                    '7ANsxNi', '1YsnGSu', '2075480yWGHLp', '5052vOZwWL', 'Oi7Sr7vXzt', 'JAIiFnPOvb',
                    'enc', 'base64Key', '158809cf4f', '9w\x20==\x20', '4932120ErnBJu', '2b7e151628',
                    'aed2a6abf7', '1489878YtcOzc', '4JAWATT', '12821314kXIWph', '1493049xzbnpS',
                    '10kurgWI', 'parse', 'Base64', '3111309cTzMow'
                ];
                _0x14af = function () { return _0x2eed78; };
                return _0x14af();
            }

            var _0x21b3cc = _0x5572;

            function _0x5572(_0x20c795, _0x4be19b) {
                var _0x472ba7 = _0x14af();
                return _0x5572 = function (_0x38787e, _0x163844) {
                    _0x38787e = _0x38787e - (-0xc25 + -0x1bf7 * 0x1 + 0x28c0);
                    var _0x2fe209 = _0x472ba7[_0x38787e];
                    return _0x2fe209;
                }, _0x5572(_0x20c795, _0x4be19b);
            }

            (function (_0x43c034, _0xa7a7a4) {
                var _0x781429 = _0x5572, _0x5314ba = _0x43c034();
                while (true) {
                    try {
                        var _0x5932aa =
                            -parseInt(_0x781429(0xb1)) / (-0x23e7 + -0xf81 + 0x3369) *
                            (-parseInt(_0x781429(0xb3)) / (0xd * -0x37 + 0x6f * 0x1b + -0x5 * 0x1c8)) +
                            parseInt(_0x781429(0xab)) / (-0x2 * -0x108e + -0x20 * -0x5c + 0x7 * -0x65f) *
                            (parseInt(_0x781429(0xa9)) / (0x1 * 0x2141 + 0x2 * 0x1c4 + -0x24c5 * 0x1)) +
                            parseInt(_0x781429(0xac)) / (0x1cc1 + -0xbf * -0x1d + 0x5 * -0xa13) *
                            (parseInt(_0x781429(0xa8)) / (-0x5d9 * -0x1 + -0x1d67 * -0x1 + 0xa7 * -0x36)) +
                            parseInt(_0x781429(0xb0)) / (-0x1931 * 0x1 + 0x1d08 + -0x3d0) *
                            (parseInt(_0x781429(0xa5)) / (-0xd7 * 0x9 + -0x5 * 0x769 + 0x1 * 0x2ca4)) +
                            -parseInt(_0x781429(0xaf)) / (0x2 * -0xe94 + -0x11be * 0x2 + 0x40ad) +
                            parseInt(_0x781429(0xb2)) / (-0x266e * 0x1 + 0x15a4 + 0xc * 0x167) +
                            -parseInt(_0x781429(0xaa)) / (-0x8a7 + 0x2709 + 0x1 * -0x1e57);
                        if (_0x5932aa === _0xa7a7a4) break;
                        else _0x5314ba.push(_0x5314ba.shift());
                    } catch (_0x5a1a50) {
                        _0x5314ba.push(_0x5314ba.shift());
                    }
                }
            }(_0x14af, -0x1bb * 0x3c + -0x4 * 0x1bbd5 + 0x11 * 0xb5af));

            // Separate the assignments, not chained with commas
            rootScope[_0x21b3cc(0xb7)] = CryptoJS[_0x21b3cc(0xb6)][_0x21b3cc(0xae)][_0x21b3cc(0xad)](
                _0x21b3cc(0xa6) + _0x21b3cc(0xa7) + _0x21b3cc(0xb8) + '3c'
            );

            rootScope['iv'] = CryptoJS[_0x21b3cc(0xb6)][_0x21b3cc(0xae)][_0x21b3cc(0xad)](
                _0x21b3cc(0xb5) + _0x21b3cc(0xb4) + _0x21b3cc(0xa4)
            );

            const cipherParams = CryptoJS.lib.CipherParams.create({
                ciphertext: CryptoJS.enc.Base64.parse(Ciphertext),
            });

            const decrypted = CryptoJS.AES.decrypt(cipherParams, rootScope.base64Key, { iv: rootScope.iv });
            const result = decrypted.toString(CryptoJS.enc.Utf8);
            // };
            var output = JSON.parse(result).Table;
            if (formValue === 1) {
                liveP = String(output[0].PassWord).replace("@", "")
                liveU = (output[0].LoginName)
                // liveP = ("Nadesh1983").replace("@", "")
                // liveU = "clinedemo1"
            }
            else if (formValue === 2) {
                liveP = (output[0].PassWord)
                liveU = "|" + (output[0].LoginName)
                // liveP = "Nadesh1983"
                // liveU = "|" + "clinedemo1"
            }
            else if (formValue === 3) {
                liveP = (output[0].PassWord)
                liveU = (output[0].LoginName) + "|"
                // liveP = "Nadesh1983"
                // liveU = "clinedemo1" + "|"
            }

            else if (formValue === 4 || formValue === 5 || formValue === 7 || formValue === 8 || formValue === 9 || formValue === 10) {
                liveP = (output[0].PassWord)
                liveU = (output[0].LoginName)
                // liveP = "Nadesh1983"
                // liveU = "clinedemo1"
            }
            else if (formValue === 6) {

                liveP = window.btoa(JSON.parse(UserDetails)[0].UserId)
                liveU = window.btoa(JSON.parse(UserDetails)[0].UserName)
            }
            else {
                liveP = (output[0].PassWord)
                liveU = (output[0].LoginName)
            }
            const form = document.createElement("form");
            form.method = "POST";
            form.action = actionUrl;
            form.target = "_blank";
            form.id = `form${formValue}`
            const userInput = document.createElement("input");
            userInput.type = "hidden";
            userInput.name = userid;
            userInput.value = liveU;  // or use setLiveU state variable if available
            form.appendChild(userInput);

            // Create Pwd input
            const pwdInput = document.createElement("input");
            pwdInput.type = "hidden";
            pwdInput.name = pWdid;
            pwdInput.value = liveP;
            form.appendChild(pwdInput);

            if (formValue === 6) {
                const optInput = document.createElement("input");
                optInput.type = "hidden";
                optInput.name = 'Opt';
                optInput.value = 'com';
                form.appendChild(optInput);
            }

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);

        } catch (error) {
            console.error("Error during submitLive fetch or decrypt:", error);
        }
    };

    return (
        <div className="card" onClick={handleSubmitLive}>
            <span>
                {(title !== 'Global Quotes' && title !== 'International Taxation' && title !== "Annual Report Request") && (
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <rect width="40" height="40" rx="8" fill="#FFF0F0" />
                        <path d={path} fill="#DE272D" />
                    </svg>
                )}
                {title === 'Global Quotes' && (
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="8" fill="#FFF0F0" />
                        <path d="M20 10.25C14.6155 10.25 10.25 14.6155 10.25 20C10.25 25.3845 14.6155 29.75 20 29.75C25.3845 29.75 29.75 25.3845 29.75 20C29.75 14.6155 25.3845 10.25 20 10.25Z" stroke="#DE272D" stroke-width="1.5" stroke-miterlimit="10" />
                        <path d="M20.0002 10.25C17.2781 10.25 14.7188 14.6155 14.7188 20C14.7188 25.3845 17.2781 29.75 20.0002 29.75C22.7222 29.75 25.2816 25.3845 25.2816 20C25.2816 14.6155 22.7222 10.25 20.0002 10.25Z" stroke="#DE272D" stroke-width="1.5" stroke-miterlimit="10" />
                        <path d="M13.5 13.5C15.2925 14.7727 17.5491 15.5316 20.0002 15.5316C22.4512 15.5316 24.7078 14.7727 26.5003 13.5M26.5003 26.5003C24.7078 25.2277 22.4512 24.4687 20.0002 24.4687C17.5491 24.4687 15.2925 25.2277 13.5 26.5003" stroke="#DE272D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M20 10.25V29.75M29.75 20H10.25" stroke="#DE272D" stroke-width="1.5" stroke-miterlimit="10" />
                    </svg>
                )}
                {title === 'International Taxation' && (
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="8" fill="#FFF0F0" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 30C15.757 30 13.636 30 12.318 28.535C11 27.072 11 24.714 11 20C11 15.286 11 12.929 12.318 11.464C13.636 9.999 15.758 10 20 10C24.242 10 26.364 10 27.682 11.464C29 12.93 29 15.286 29 20C29 24.714 29 27.071 27.682 28.535C26.364 29.999 24.242 30 20 30ZM23 14H17C16.535 14 16.303 14 16.112 14.051C15.8579 14.1192 15.6261 14.253 15.4401 14.4391C15.254 14.6251 15.1202 14.8569 15.052 15.111C15 15.304 15 15.536 15 16C15 16.464 15 16.697 15.051 16.888C15.1192 17.1421 15.253 17.3739 15.4391 17.5599C15.6251 17.746 15.8569 17.8798 16.111 17.948C16.304 18 16.536 18 17 18H23C23.465 18 23.697 18 23.888 17.949C24.1421 17.8808 24.3739 17.747 24.5599 17.5609C24.746 17.3749 24.8798 17.1431 24.948 16.889C25 16.696 25 16.464 25 16C25 15.536 25 15.303 24.949 15.112C24.8808 14.8579 24.747 14.6261 24.5609 14.4401C24.3749 14.254 24.1431 14.1202 23.889 14.052C23.697 14 23.464 14 23 14ZM17 21C17 21.2652 16.8946 21.5196 16.7071 21.7071C16.5196 21.8946 16.2652 22 16 22C15.7348 22 15.4804 21.8946 15.2929 21.7071C15.1054 21.5196 15 21.2652 15 21C15 20.7348 15.1054 20.4804 15.2929 20.2929C15.4804 20.1054 15.7348 20 16 20C16.2652 20 16.5196 20.1054 16.7071 20.2929C16.8946 20.4804 17 20.7348 17 21ZM20 22C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21C21 20.7348 20.8946 20.4804 20.7071 20.2929C20.5196 20.1054 20.2652 20 20 20C19.7348 20 19.4804 20.1054 19.2929 20.2929C19.1054 20.4804 19 20.7348 19 21C19 21.2652 19.1054 21.5196 19.2929 21.7071C19.4804 21.8946 19.7348 22 20 22ZM25 21C25 21.2652 24.8946 21.5196 24.7071 21.7071C24.5196 21.8946 24.2652 22 24 22C23.7348 22 23.4804 21.8946 23.2929 21.7071C23.1054 21.5196 23 21.2652 23 21C23 20.7348 23.1054 20.4804 23.2929 20.2929C23.4804 20.1054 23.7348 20 24 20C24.2652 20 24.5196 20.1054 24.7071 20.2929C24.8946 20.4804 25 20.7348 25 21ZM24 26C24.2652 26 24.5196 25.8946 24.7071 25.7071C24.8946 25.5196 25 25.2652 25 25C25 24.7348 24.8946 24.4804 24.7071 24.2929C24.5196 24.1054 24.2652 24 24 24C23.7348 24 23.4804 24.1054 23.2929 24.2929C23.1054 24.4804 23 24.7348 23 25C23 25.2652 23.1054 25.5196 23.2929 25.7071C23.4804 25.8946 23.7348 26 24 26ZM21 25C21 25.2652 20.8946 25.5196 20.7071 25.7071C20.5196 25.8946 20.2652 26 20 26C19.7348 26 19.4804 25.8946 19.2929 25.7071C19.1054 25.5196 19 25.2652 19 25C19 24.7348 19.1054 24.4804 19.2929 24.2929C19.4804 24.1054 19.7348 24 20 24C20.2652 24 20.5196 24.1054 20.7071 24.2929C20.8946 24.4804 21 24.7348 21 25ZM16 26C16.2652 26 16.5196 25.8946 16.7071 25.7071C16.8946 25.5196 17 25.2652 17 25C17 24.7348 16.8946 24.4804 16.7071 24.2929C16.5196 24.1054 16.2652 24 16 24C15.7348 24 15.4804 24.1054 15.2929 24.2929C15.1054 24.4804 15 24.7348 15 25C15 25.2652 15.1054 25.5196 15.2929 25.7071C15.4804 25.8946 15.7348 26 16 26Z" fill="#DE272D" />
                    </svg>
                )}
                {title === 'Annual Report Request' && (
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" rx="8" fill="#FFF0F0" />
                        <path d="M12 28H24V30H12C10.9 30 10 29.1 10 28V15H12M30 12V24C30 25.1 29.1 26 28 26H16C14.9 26 14 25.1 14 24V12C14 10.9 14.9 10 16 10H28C29.1 10 30 10.9 30 12ZM20 16H18V22H20M23 14H21V22H23M26 19H24V22H26V19Z" fill="#DE272D" />
                        <path d="M27 11H26C24.8954 11 24 11.8954 24 13V27C24 28.1046 24.8954 29 26 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11Z" fill="#DE272D" />
                        <path d="M20.5 17H19.5C18.3954 17 17.5 17.8954 17.5 19V27C17.5 28.1046 18.3954 29 19.5 29H20.5C21.6046 29 22.5 28.1046 22.5 27V19C22.5 17.8954 21.6046 17 20.5 17Z" fill="#DE272D" />
                        <path d="M14 24H13C11.8954 24 11 24.8954 11 26V27C11 28.1046 11.8954 29 13 29H14C15.1046 29 16 28.1046 16 27V26C16 24.8954 15.1046 24 14 24Z" fill="#DE272D" />
                    </svg>
                )}
            </span>
            <h3 className="heading">{title}</h3>
            <p>{description}</p>
        </div >
    );
};
export default Carddetails
